import React from 'react';

interface CompanyFooterInfoProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

export const CompanyFooterInfo: React.FC<CompanyFooterInfoProps> = ({ formData, handleChange }) => {
  return (
    <div className="form-section">
      <h3>Footer Information</h3>
      <div className="form-group">
        <label htmlFor="footer_legal_text">Legal Footer Text</label>
        <textarea
          id="footer_legal_text"
          name="footer_legal_text"
          value={formData.footer_legal_text}
          onChange={handleChange}
          rows={3}
          className="form-control"
          placeholder="Legal text to appear in invoice footers"
        />
      </div>
      <div className="form-group">
        <label htmlFor="footer_payment_terms">Payment Terms</label>
        <textarea
          id="footer_payment_terms"
          name="footer_payment_terms"
          value={formData.footer_payment_terms}
          onChange={handleChange}
          rows={3}
          className="form-control"
          placeholder="Payment terms to appear in invoices"
        />
      </div>
    </div>
  );
};